<template>
  <div class="app-container pull-auto notice-list">
    <div class="notice-list-filter">
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <label class="notice-list-filter-label">内容</label>
            <el-input class="notice-list-filter-value" v-model="listQuery.msgContent" clearable size="small"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <label class="notice-list-filter-label">发送者</label>
            <el-input class="notice-list-filter-value" v-model="listQuery.msgFromName" 
                clearable size="small"></el-input>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <label class="notice-list-filter-label">接受者</label>
            <el-input class="notice-list-filter-value" v-model="listQuery.msgToName" 
                clearable size="small"></el-input>
          </div>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <label class="notice-list-filter-label">会话ID</label>
            <el-input class="notice-list-filter-value" v-model="listQuery.convId" 
                clearable size="small"></el-input>
          </div>
        </el-col>
        <el-col :span="9">
          <div class="grid-content bg-purple">
            <label class="notice-list-filter-label">发送时间</label>
            <el-date-picker
               class="notice-list-filter-date"
              v-model="listQuery.searchTime"
              type="daterange"
              value-format="yyyy-MM-dd"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              size="small">
            </el-date-picker>
          </div>
        </el-col>
        <div>
          <el-button class="notice-list-filter-search" size="small" @click="searchReset">清空</el-button>
          <el-button class="notice-list-filter-reset" type="primary" size="small" @click="searchChange">搜索</el-button>
        </div>
      </el-row>
    </div>

    <basic-container>
      <avue-crud
          ref="noticeCrud"
          :page="noticePage"
          :data="noticeTableData"
          :table-loading="noticeTableLoading"
          :option="noticeTableOption"
          @current-change="noticeCurrentChange"
          @refresh-change="getList"
          @size-change="noticeSizeChange">

        <template slot="msgContent" slot-scope="scope">
          <div v-if="scope.row.msgType == 1">
            <a href="javascript:void(0);" @click="toPostDetail(scope.row.msgContent.postId);" class="notice-list-container-button"> {{scope.row.msgContent.title}}</a>
          </div>
          <div v-else>
            {{scope.row.msgContent}}
          </div>
        </template>

        <template slot="msgFromName"
                  slot-scope="scope">
          <a href="javascript:void(0);" @click="toMemberDetail(scope.row.msgFrom);"
            class="notice-list-container-button">
            {{scope.row.msgFromName}}</a>
        </template>

        <template slot="msgToName"
                  slot-scope="scope">
          <a href="javascript:void(0);" @click="toMemberDetail(scope.row.msgTo);"
            class="notice-list-container-button">
            {{scope.row.msgToName}}</a>
        </template>

        <template slot="msgContent" slot-scope="scope">
          <div v-if="scope.row.msgType === 0">{{scope.row.msgContent}}</div>
          <div v-else-if="scope.row.msgType === 2">
            <img :src="scope.row.msgContent" style="max-width:50px;max-height:50px;" v-viewer>
          </div>
          <div v-else>{{scope.row.msgContent}}</div>
        </template>
        
      </avue-crud>
    </basic-container>
  </div>
</template>

<script>
  import { fetchUserMsgList } from '@/api/msg/notice'
  import { noticeTableOption } from '@/const/crud/msg/user'
  import { mapGetters } from 'vuex'
  export default {
    name: 'user',
    data() {
      return {
        // 搜索功能
        listQuery: {
          current: 1,
          size: 20,
          msgFromName: "",
          msgToName: "",
          searchTime: [],
          msgContent: "",
          convId: undefined,
        }, 

        // 列表页面
        noticeTableData: [],
        noticePage: {
          total: 0, // 总页数
          currentPage: 1, // 当前页数
          pageSize: 20 // 每页显示多少条
        },
        noticeTableLoading: false,
        noticeTableOption: noticeTableOption,
      }
    },
    created() {
      this.getList()
    },
    mounted: function() { },
    computed: {
      ...mapGetters(['permissions']),
      startTime: function () {
        if (this.listQuery.searchTime && this.listQuery.searchTime.length > 0) {
          return this.listQuery.searchTime[0]
        } else {
          return null
        }
      },
      endTime: function () {
        if (this.listQuery.searchTime && this.listQuery.searchTime.length > 1) {
          return this.listQuery.searchTime[1]
        } else {
          return null
        }
      }
    },
    methods: {
      formatData(records) {
        let _this = this
        if (records && records.length > 0) {
          records.forEach(function(record, index) {

            if (record.msgType == 1) {
              record.msgContent = JSON.parse(record.msgContent);
            }
            if (record.msgToName == null || record.msgToName == '') {
              record.msgToName = "--"
            } else {
              if (record.msgToIsAnonymous != undefined && record.msgToIsAnonymous == 1) {
                record.msgToName = record.msgToName + "(匿名)"
              }
            }
            if (record.msgFromName == null || record.msgFromName == '') {
              record.msgFromName = "--"
            } else {
              if (record.msgToIsAnonymous != undefined && record.msgFromIsAnonymous == 1) {
                record.msgFromName = record.msgFromName + "(匿名)"
              }
            }
          })
        }
        return records
      },
      getList() {
        // 获取用户消息列表
        let params = {
          current: this.listQuery.current,
          size: this.listQuery.size
        }
        // 增加搜索功能
        if (this.listQuery.msgContent != "" && this.listQuery.msgContent.trim() != "")
          params.msgContent = this.listQuery.msgContent
        
        if (this.listQuery.msgToName != "" && this.listQuery.msgToName.trim() != "")
          params.msgToName = this.listQuery.msgToName
        if (this.listQuery.msgFromName != "" && this.listQuery.msgFromName.trim() != "")
          params.msgFromName = this.listQuery.msgFromName
        if (this.startTime && this.endTime) {
          params.sentStartTime = this.startTime
          let t = new Date(this.endTime)
          t.setDate(t.getDate() + 1)
          params.sentEndTime = t.getFullYear() + '-' + (t.getMonth() + 1) + '-' + t.getDate()
        } else {
          params.sentStartTime = null
          params.sentEndTime = null
        }

        params.convId = this.listQuery.convId

        this.noticeTableLoading = true

        fetchUserMsgList(params).then(response => {
          this.noticeTableData = this.formatData(response.data.data.records)
          this.noticePage.total = response.data.data.total
          this.noticeTableLoading = false
        })
      },
      noticeCurrentChange(val) {
        this.noticePage.current = val
        this.listQuery.current = val
        this.getList()
      },
      noticeSizeChange(val) {
        this.noticePage.size = val
        this.listQuery.size = val
        this.getList()
      },
      initPage() {
        this.noticePage.currentPage = 1
        this.noticePage.pageSize = this.listQuery.size
        this.listQuery.current = 1
        this.listQuery.sortField = ""
        this.listQuery.sortPolicy = ""
      },
      searchChange() {
        this.initPage()
        this.getList()
      },
      searchReset() {
        this.listQuery.msgContent = ""
        this.listQuery.msgFromName = ""
        this.listQuery.msgToName = ""
        this.listQuery.searchTime = []
        this.listQuery.convId = ""
        this.searchChange()
      },

      toLinkPage(entityType, entityId) {

        let pagePath = ''
        if (entityType == 0) { pagePath = "/post/posts/detail/" + entityId}
        else if (entityType == 1) { pagePath = "/post/essay/detail/" + + entityId }
        else if (entityType == 2) { pagePath = "/post/circle/detail/" + + entityId }
        else if (entityType == 3) { pagePath = "/post/column/detail/" + + entityId }
        else if (entityType == 4) { pagePath = "/post/circle/detail/" + + entityId }
        else if (entityType == 5) { pagePath = "/upms/member/detail/" + + entityId }

        this.$router.push({
          path: pagePath,
        })
      },
      toMemberDetail(noticeToId) {
        // 列表里点击接收者，链接转到该接收者的会员详情
        this.$router.push({
          path: "/upms/member/detail/" + noticeToId,
        })
      },
      toPostDetail(postId) {
        // 列表里点击帖子，链接转到该帖子详情
        this.$router.push({
          path: "/post/posts/detail/" + postId,
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
.notice-list {
  &-filter {
    margin: 0px 10px;
    background-color: #fff;
    padding-top: 20px;
    padding-left: 22px;
    &-label {
      font-size: 14px;
      color: #606266;
      margin-right: 10px;
    }
    &-value {
      width: calc(100% - 90px) !important;
    }
    &-date {
      width: calc(100% - 150px) !important;
    }
    &-search {
      float: right;
      margin-right: 50px;
    }
    &-reset {
      float: right;
      margin-right: 10px;
    }
  }
  &-container {
    padding-top: 0px;
    &-button {
      color: #409EFF;
      font-size: 14px;
      text-align: center;
      font-weight: 500;
    }
  }
}
</style>
